import { createContext, useContext } from "react";
import { wrapProvider } from "analytics/helpers";

export const defaultValue: SegmentContext = {
  track: () => undefined,
  identify: () => undefined,
  reset: () => undefined,
  commonProps: {
    filters: {},
    sort: [],
  },
  setCommonProps: () => undefined,
};
export const Context = createContext(defaultValue);
export const Provider = wrapProvider(Context, defaultValue);
export const Consumer = Context.Consumer;
export const useSegment = () => useContext(Context);
